import { http } from "../../drivers/data";

http.events.beforeSending(options => {
  options.headers["Accept-Language"] = document.documentElement.lang;
});
